
import { useEffect, useState } from "react";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import { ProfileEmpty, ProfileSection, ProfileSectionError } from "../common/ProfileSection";
import Visit from "./Visit";

export default function VisitSection({ isDesktop }) {
	const [visits, setVisits] = useState([]);
	const [errorMessage, setErrorMessage] = useState("");

	useEffect(() => {
		fetchVisits();
	}, []);

	function fetchVisits() {
		api.visitListMine({
			token: LoginHelper.getToken(),
		})
			.then((results) => {
				setVisits(results);
			})
			.catch((err) => {
				if (err && err.data) {
					setErrorMessage(err.data.message);
				}
			});
	}

	return (
		<ProfileSection title="نوبت‌ها">
			{visits.length >= 1 ? (
				<div className={`grid gap-4 ${isDesktop ? "grid-cols-4" : "grid-cols-1"}`}>
					{visits.map((visit) => (
						<Visit key={visit.id} visit={visit} />
					))}
				</div>
			) : (
				<ProfileEmpty>نوبتی وجود ندارد</ProfileEmpty>
			)}
			<ProfileSectionError message={errorMessage} />
		</ProfileSection>
	);
}
